var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10999_19442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5013 17.5004H3.0013C2.54047 17.5004 2.16797 17.1271 2.16797 16.6671V10.0004C2.16797 9.54045 2.54047 9.16711 3.0013 9.16711H5.5013C5.96214 9.16711 6.33464 9.54045 6.33464 10.0004V16.6671C6.33464 17.1271 5.96214 17.5004 5.5013 17.5004ZM11.3346 17.5004H8.83463C8.3738 17.5004 8.0013 17.1271 8.0013 16.6671V2.50045C8.0013 2.04045 8.3738 1.66711 8.83463 1.66711H11.3346C11.7955 1.66711 12.168 2.04045 12.168 2.50045V16.6671C12.168 17.1271 11.7955 17.5004 11.3346 17.5004ZM17.168 17.5004H14.668C14.2071 17.5004 13.8346 17.1271 13.8346 16.6671V7.50045C13.8346 7.04045 14.2071 6.66711 14.668 6.66711H17.168C17.6288 6.66711 18.0013 7.04045 18.0013 7.50045V16.6671C18.0013 17.1271 17.6288 17.5004 17.168 17.5004Z",
    fill: "#A6B0CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10999_19442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0521,
    height: 20.0521,
    fill: "white",
    transform: "translate(0.65625 0.473999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.a891f933.svg";
export { ForwardRef as ReactComponent };